// Lazy-loaded PDF text extraction. pdfjs-dist is large (~300KB gzipped) so we
// only pull it in once the user actually picks a PDF file.

const MAX_CHARS = 20_000;

export async function extractPdfText(file: File): Promise<string> {
  const pdfjs = await import('pdfjs-dist');
  // Vite-friendly worker URL
  const workerUrl = (
    await import('pdfjs-dist/build/pdf.worker.min.mjs?url')
  ).default;
  pdfjs.GlobalWorkerOptions.workerSrc = workerUrl;

  const buf = await file.arrayBuffer();
  const doc = await pdfjs.getDocument({ data: buf }).promise;

  const parts: string[] = [];
  for (let i = 1; i <= doc.numPages; i++) {
    const page = await doc.getPage(i);
    const content = await page.getTextContent();
    const pageText = content.items
      .map((item) => ('str' in item ? item.str : ''))
      .join(' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (pageText) parts.push(pageText);
    if (parts.join('\n\n').length > MAX_CHARS) break;
  }

  const text = parts.join('\n\n').trim();
  return text.length > MAX_CHARS ? text.slice(0, MAX_CHARS) : text;
}

export async function readTextFile(file: File): Promise<string> {
  const text = await file.text();
  return text.length > MAX_CHARS ? text.slice(0, MAX_CHARS) : text;
}
